/**
 * @Author:      
 * @DateTime:    
 * @Description: 后台-登录管理-二级域名设置
 */
'use strict';
angular.module("setSuccessModule", []).
controller('setSuccessCtrl', ['$scope', '$state','$stateParams','httpService', function($scope, $state,$stateParams,httpService) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.domainname = $stateParams.domainname;
	}
	function initData(){
		getDomainInfo();
	}
	
	function getDomainInfo() {
		httpService.http("/mcnadmin/admin/tenant/getCurrTenantConfig.do", '', "post").then(function(data) {
			console.log(data)
			if(data.data && data.data.domainPrefix) {
				$scope.webUrl = data.webUrl
			}
		});
	}
}]);